import { render, staticRenderFns } from "./day-default.vue?vue&type=template&id=1ae2003d&"
import script from "./day-default.vue?vue&type=script&lang=ts&"
export * from "./day-default.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ae2003d')) {
      api.createRecord('1ae2003d', component.options)
    } else {
      api.reload('1ae2003d', component.options)
    }
    module.hot.accept("./day-default.vue?vue&type=template&id=1ae2003d&", function () {
      api.rerender('1ae2003d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Availability/submodule/Calendar/view/vue/components/days/day-default.vue"
export default component.exports